import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchEnabledOptimizations } from "#modules/optimizations/infra/fetchEnabledOptimizations.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const enabledOptimizationsQuery = ({ quoteRequestId }: { quoteRequestId: string }) => ({
  queryKey: queryKeys.optimizations.enabledByQuoteRequest(quoteRequestId),
  queryFn: () => fetchEnabledOptimizations(quoteRequestId),
  staleTime: STALE_TIME,
});
